import React from 'react';
import { TextArrayField, type TextArrayFieldProps } from '../base-fields/TextArrayField';
import { useFormField } from '../../useFormField';
import { useField } from 'formik';
import type { StripControlledProperties } from '../../types';

export const TextArrayFormField = React.memo(function TextArrayFormFieldComponent(props: StripControlledProperties<TextArrayFieldProps>) {
	const fieldProps = useFormField<string[]>(props);
	const [, meta] = useField<string[]>(props.name);

	const itemErrors = meta.touched && Array.isArray(meta.error) ? (meta.error as (string | undefined)[]) : undefined;

	return (
		<TextArrayField
			{...props}
			value={fieldProps.value ?? []}
			onChange={fieldProps.onChange}
			onBlur={fieldProps.onBlur}
			label={fieldProps.label}
			required={fieldProps.required}
			isReadOnly={fieldProps.isReadOnly}
			isInvalid={fieldProps.isInvalid}
			itemErrors={itemErrors}
		/>
	);
});
